import { render, staticRenderFns } from "./stored-value-order.vue?vue&type=template&id=246061cb"
import script from "./stored-value-order.vue?vue&type=script&lang=js"
export * from "./stored-value-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports